import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { notification } from 'ant-design-vue';
import router from '@/router';
import i18n from '@/i18n';
import { RouteNames } from '@/enums/routes/RouteNames';
import moment from 'moment';
import Resource from '@/models/Resource';
import ResourceRepository from '@/repositories/ResourceRepository';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarResources',
  setup(__props) {

const loading = ref(false);

const resources = computed(() => ResourceRepository.getAll());
const fields = computed(() => [
    {
        title: i18n.t('Naziv'),
        key: 'title',
        dataIndex: 'title',
    },
    {
        title: i18n.t('Opis'),
        key: 'description',
        dataIndex: 'description',
    },
    {
        title: i18n.t('Datum'),
        key: 'dateInserted',
        dataIndex: 'dateInserted',
        scopedSlots: {
            customRender: 'date',
        },
    },
    {
        title: i18n.t('Akcije'),
        key: 'actions',
        dataIndex: 'actions',
        scopedSlots: {
            customRender: 'actions',
        },
    },
]);

async function retrieveResources() {
    loading.value = true;
    try {
        await Resource.getAll();
    } catch (e) {
        notification.error({
            message: i18n.t('Dogodila se greška') as string,
            description: (e as Error).message,
        });
        return Promise.reject();
    } finally {
        loading.value = false;
    }
}

function editItem(itemId: string) {
    router.push({
        name: RouteNames.schedulesResources,
        params: { id: itemId.toString(), dynamic: 'CalendarResourceEdit' },
    });
}

function addResource() {
    router.push({
        name: RouteNames.schedulesResources,
        params: { dynamic: 'CalendarResourceEdit' },
    });
}

async function deleteResource(id: string) {
    loading.value = true;
    await Resource.deleteExisting(id);
    await retrieveResources();
}

onMounted(async () => {
    await retrieveResources();
});

return { __sfc: true,loading, resources, fields, retrieveResources, editItem, addResource, deleteResource, moment }
}

})